var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("请注意，选择【生成】即扣除报告下载次数\n  "),(!_vm.isOrg)?[_vm._v("\n    ,"),_c('br'),_vm._v("\n    若当前账户内没有剩余下载次数，可以购买单篇报告，"),_c('br'),_vm._v("\n    或者点击右上角【会员套餐】购买超值套餐\n  ")]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-157dff54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/index/GenDialog.vue
// module id = null
// module chunks = 